// extracted by mini-css-extract-plugin
module.exports = {"open":"styles_open__KyP7B","close":"styles_close__jBj_o","arrow":"styles_arrow__hOXxm","small":"styles_small__2NrdO","medium":"styles_medium__96aGz"};